<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="user_username"
        class="form-control-label">username</label>
        <input
          id="user_username"
          v-model="item.username"
          :class="['form-control', !isValid('username') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('username')"
        class="invalid-feedback">{{ violations.username }}</div>
    </div>
    <div class="form-group">
      <label
        for="user_password"
        class="form-control-label">password</label>
        <input
          id="user_password"
          v-model="item.password"
          :class="['form-control', !isValid('password') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('password')"
        class="invalid-feedback">{{ violations.password }}</div>
    </div>
    <div class="form-group">
      <label
        for="user_testimonial"
        class="form-control-label">testimonial</label>
        <select
          v-model="item.testimonial"
          id="user_testimonial"
          multiple
          class="form-control"
        >
          <option v-for="selectItem in testimonialSelectItems"
                  :key="selectItem['@id']"
                  :value="selectItem['@id']"
                  :selected="isSelected('testimonial', selectItem['@id'])">{{ selectItem.name }}
          </option>
        </select>
      <div
        v-if="!isValid('testimonial')"
        class="invalid-feedback">{{ violations.testimonial }}</div>
    </div>
    <div class="form-group">
      <label
        for="user_email"
        class="form-control-label">email</label>
        <input
          id="user_email"
          v-model="item.email"
          :class="['form-control', !isValid('email') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('email')"
        class="invalid-feedback">{{ violations.email }}</div>
    </div>
    <div class="form-group">
      <label
        for="user_notificationToken"
        class="form-control-label">notificationToken</label>
        <input
          id="user_notificationToken"
          v-model="item.notificationToken"
          :class="['form-control', !isValid('notificationToken') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('notificationToken')"
        class="invalid-feedback">{{ violations.notificationToken }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-success">Submit</button>
  </form>
</template>

<script>
  import { find, get, isUndefined } from 'lodash';
  import { mapFields } from 'vuex-map-fields';
  import { mapActions } from 'vuex';

  export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true,
    },

    values: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      default: () => {},
    },

    initialValues: {
      type: Object,
      default: () => {},
    }
  },

  mounted() {
    this.testimonialGetSelectItems();
  },

  computed: {
    ...mapFields('testimonial/list', {
      'testimonialSelectItems': 'selectItems',
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
        testimonialGetSelectItems: 'testimonial/list/getSelectItems',
    }),

    isSelected(collection, id) {
      return find(this.item[collection], ['@id', id]) !== undefined;
    },

    isValid(key) {
      return isUndefined(get(this.violations, key));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/user/Form.vue